require('babel-polyfill')
require('normalize.css')
require('lightslider')
require('lightslider/dist/css/lightslider.css')
// require('@fengyuanchen/datepicker/dist/datepicker.js')
// require('@fengyuanchen/datepicker/dist/datepicker.css')

require('./js/daterangepicker.js')
require('./js/map.js')
require('./js/main.js')
require('./css/main.scss')

// require images
function requireAll(r) {
  r.keys().forEach(r)
}
requireAll(require.context('./img', true, /\.(gif|png|jpe?g|svg|ico)$/))



// WEBPACK FOOTER //
// ./src/index.js